<!-- 移除黑名单接口内容 -->
<template>
  <div class>
    <right-structure :Pdatas="infoData">
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
import structure from "@/components/commonStructure";

export default {
  name: "",
  components: {
    "right-structure": structure
  },
  props: ["commonUrls"],
  data() {
    return {
      requestBody: { parkCode: "2KNTYVWC", carNo: "粤YGW982", blacklistId: 68 },
      responseCode: {
        data: {},
        message: "业务成功",
        resultCode: 0,
        status: 1
      },
      infoData: {
        explain: "第三方接入系统请求智慧停车开放平台取消某个黑名单车辆",
        t_url: this.commonUrls.test + "removeBlackListCar",
        p_url: this.commonUrls.prod + "removeBlackListCar",
        precondition: "无",
        fitSystem: "VEMS传统停车场，云停车场",
        pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
        Q_params: [
          {
            titleName: null,
            tabledata: [
              { tableHead: "参数名", tdName: "info1" },
              { tableHead: "是否必填", tdName: "info2" },
              {
                tableHead: "类型",
                tdName: "info3"
              },
              { tableHead: "说明", tdName: "info4" }
            ],
            td: [
              {
                info1: "parkCode",
                info2: "是",
                info3: "String",
                info4: "停车场编号"
              },
              {
                info1: "blacklistId",
                info2: "否",
                info3: "String",
                info4:
                  "黑名单ID，与车牌号二选一，同时传时优先使用黑名单ID，使用黑名单ID时为精确取消，仅使用车牌时取消该车牌黑名单"
              },
              {
                info1: "carNo",
                info2: "否",
                info3: "String",
                info4:
                  "车牌号，与黑名单ID二选一，同时传时优先使用黑名单ID，使用黑名单ID时为精确取消，仅使用车牌时取消该车牌黑名单"
              }
            ]
          }
        ],
        R_params: [
          {
            titleName: null,
            tabledata: [
              { tableHead: "参数名", tdName: "info1" },
              { tableHead: "是否必填", tdName: "info2" },
              {
                tableHead: "类型",
                tdName: "info3"
              },
              { tableHead: "说明", tdName: "info4" }
            ],
            td: []
          }
        ],
        codeStatus: [
          {
            titleName: null,
            tabledata: [
              { tableHead: "状态码", tdName: "info1" },
              { tableHead: "说明", tdName: "info2" }
            ],
            td: [
              { info1: "000110", info2: "失败" },
              { info1: "00110000", info2: "失败" },
              { info1: "110000", info2: "失败" }
            ]
          }
        ]
      }
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/blacklist/removeBlackListCar.vue